import { SearchQuery } from "shared/data/reducers/types/storage";
import { getFlightCombinationsTree } from "shared/gol-api/flightSearch";
import FlightOffer from "shared/types/flightOffer";

import isDirectOnly from "../isDirectOnly";

const filterMaxTransfers = (searchQuery: SearchQuery) => (
  flightOffer: FlightOffer
) => {
  if (searchQuery.max_transfers === undefined) {
    return true;
  }

  const maxTransfers = isDirectOnly(searchQuery.max_transfers)
    ? 0
    : Number(searchQuery.max_transfers);

  if (!Number.isFinite(maxTransfers)) {
    return true;
  }

  const availableFlightStreams = flightOffer.FlightItinerary.FlightStream.map(
    (flightStream) =>
      flightStream.filter(
        (flightOption) => flightOption.numTransfers <= maxTransfers
      )
  );

  if (
    availableFlightStreams.some((flightStream) => flightStream.length === 0)
  ) {
    return false;
  }

  const availableFlightOptionKeys = new Set(
    availableFlightStreams.flatMap((flightStream) =>
      flightStream.map(({ Key }) => Key)
    )
  );
  const availableFlightCombinations = flightOffer.FlightCombinations.filter(
    (flightCombination) =>
      flightCombination.FlightOptionCombinations.FlightOptionCombination.every(
        ({ Key }) => availableFlightOptionKeys.has(Key)
      )
  );

  if (availableFlightCombinations.length === 0) {
    return false;
  }

  // eslint-disable-next-line no-param-reassign
  flightOffer.FlightItinerary.FlightStream = availableFlightStreams;
  // eslint-disable-next-line no-param-reassign
  flightOffer.FlightCombinations = availableFlightCombinations;
  // eslint-disable-next-line no-param-reassign
  flightOffer.CurrentCombinations = getFlightCombinationsTree(
    availableFlightCombinations
  );

  return true;
};

export default filterMaxTransfers;
